import { Component, OnInit } from '@angular/core';
import { PdfMakeWrapper, Img } from 'pdfmake-wrapper';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
// importing definitions
import { Txt, Columns, Table, Ul, Ol } from 'pdfmake-wrapper';
import { AuthService } from 'src/app/services/auth.service';
import { ThrowStmt } from '@angular/compiler';
import { map } from 'rxjs/operators';
import { Observable, of, Subject } from 'rxjs';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { ActivatedRoute,Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
//import * as Excel from "exceljs";
import * as Excel from 'exceljs/dist/exceljs.min.js'
import * as fs from 'file-saver';


@Component({
  selector: 'app-fmtcharter',
  templateUrl: './fmtcharter.component.html',
  styleUrls: ['./fmtcharter.component.scss']
})
export class FmtcharterComponent implements OnInit {
  constructor(     
      public authService: AuthService, 
      private route: ActivatedRoute,
      private _sanitizer: DomSanitizer,
      private router: Router){ 
  }
  itm={
    id:0,
    id_matriz:1,
    nombre:"",
    numero:"",
    objetivo:"",
    facilitador:"",
    patrocinador:"",
    vpmexico:"",
  }
  fechaini="";
  fechaestini;
  fechaestfin;

  fechapat;
  fechavp;

  
  bRegistro: boolean=false;

  
  ant = []
  txtant = "";
  est = []
  txtest = "";
  ent = []
  txtent = "";

  int;
  lstint = []
  selint;

  equ;
  lstequ = []
  selequ;

  mat = []
  txtmat = "";

  cap = []
  txtcap = "";

  lst;

  id_charter;
  charter;
  id_n;
  ngOnInit() {     
    this.id_charter=localStorage.getItem("id_charter");         
    var t= localStorage.getItem("tpo");    
    console.log(t)    
    switch (t) {
      case 'P':
        this.Pgg4();
        break;
      case 'X':case 'x':
        
        this.generateExcel();
          break;    
      default:
        break;
    }
  }
  async Pgg4(){
   
    const pdf = new PdfMakeWrapper(); 
    var sqry;

    
    sqry = " select" +
           " id, id_matriz, nombre, numero, objetivo, facilitador, patrocinador, vpmexico, fechaini," +
           " fechaestini,fechaestfin,fechapat,fechavp" +
           " from tblcharter_cha" +
           " where id_matriz = " +this.id_charter +
           " order by nombre";
   
    console.log(sqry)
    await this.authService.ejecuta1(sqry)
    .then(
      data  => {    
       
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        console.log(res);    
        if (res.length!=0){
          this.id_n=res[0].id;
          this.charter=data;
          
        }else{
          this.id_n=0;
          this.charter=null;
        }            
    },
    error => {
    });

    //console.log(this.id_n);
    pdf.pageOrientation("landscape");  
    pdf.pageSize("letter")
    pdf.add(new Txt("Charter")
      .alignment('center').color("black").bold().fontSize(16).end);  
    
    if (this.id_n>0){
      var itm=this.charter[0];
      this.itm.id = itm.id;          
      pdf.add(new Table([             
        [{text:"Nombre del proyecto: ",fillColor: '#B0A879',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}, 
        {text:this.charter[0].nombre,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}], 
       ]).widths([100,590]).fontSize(10).bold().alignment('left').end);
      pdf.add(new Table([             
        [{text:"Número de proyecto: ",fillColor: '#B0A879',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}, 
        {text:this.charter[0].numero,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}, 
        {text:"Fecha de inicio",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
        {text:this.charter[0].fechaini,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
        {text:"ID del proyecto",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
        {text:this.charter[0].id,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}]
       ]).widths([100,117,100,124,100,112]).fontSize(10).bold().alignment('left').end);       
       //+++++++++++++++++++++++++++++++++++++++++++++++++++
       pdf.add(new Table([             
        [ {text:"Antecedentes:",fillColor: '#B0A879',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#FFFFFF']}, 
          {text:"No",fillColor: '#B0A879',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#CCCCCC']}, 
          {text:"Antecedente",fillColor: '#B0A879',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#CCCCCC']}]
       ]).widths([100,20,560]).fontSize(10).bold().alignment('left').end);       
       var sqry;
       sqry = " select" +
              " id, nombre" +
              " from tblantecedente_cha" +
              " where id_charter = " + itm.id +
              " order by nombre";
       //console.log(sqry);
       await this.authService.ejecuta1(sqry)
       .then(
         data  => {        
           //this.loading =  false;                        
           var dat = JSON.stringify(data);
           var res = JSON.parse(dat);     
           if (res.length!=0){
             for(var i = 0; i < res.length;i++){               
               pdf.add(new Table([             
                [ {text:"",fillColor: '#B0A879',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#FFFFFF']}, 
                  {text:i+1,borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#CCCCCC']}, 
                  {text:res[i].nombre,borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#CCCCCC']}]
               ]).widths([100,20,560]).fontSize(10).bold().alignment('left').end);                
             }
           }
       },
       error => {
           //this.loading =  false;
           //msg.fire('Datos incorrectos', '', 'error');
       });
       //+++++++++++++++++++++++++++++++++++++++++++++++++++
       pdf.add(new Table([             
        [ {text:"Objetivo:",fillColor: '#B0A879',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#CCCCCC']}, 
          {text:itm.objetivo,borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#CCCCCC']}]
       ]).widths([100,590]).fontSize(10).bold().alignment('left').end); 
      //+++++++++++++++++++++++++++++++++++++++++++++++++++
      pdf.add(new Table([             
        [ {text:"Estrategia para alcanzar el objetivo:",fillColor: '#B0A879',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#FFFFFF']}, 
          {text:"No",fillColor: '#B0A879',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#CCCCCC']}, 
          {text:"Estrategia",fillColor: '#B0A879',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#CCCCCC']}]
       ]).widths([100,20,560]).fontSize(10).bold().alignment('left').end);       
       var sqry;
       sqry = " select" +
             " id, nombre" +
             " from tblestrategia_cha" +
             " where id_charter = " + itm.id +
             " order by nombre"; 
       //console.log(sqry);
       await this.authService.ejecuta1(sqry)
       .then(
         data  => {        
           //this.loading =  false;                        
           var dat = JSON.stringify(data);
           var res = JSON.parse(dat);     
           if (res.length!=0){ 
             for(var i = 0; i < res.length;i++){               
               pdf.add(new Table([             
                [{text:"",fillColor: '#B0A879',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#FFFFFF']}, 
                  {text:i+1,borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#CCCCCC']}, 
                  {text:res[i].nombre,borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#CCCCCC']},]
               ]).widths([100,20,560]).fontSize(10).bold().alignment('left').end);                
             }
           }           
       });
       //+++++++++++++++++++++++++++++++++++++++++++++++++++
       //+++++++++++++++++++++++++++++++++++++++++++++++++++
      pdf.add(new Table([             
        [ {text:"Entregables:",fillColor: '#B0A879',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#FFFFFF']}, 
          {text:"No",fillColor: '#B0A879',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#CCCCCC']}, 
          {text:"Entregable",fillColor: '#B0A879',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#CCCCCC']}]
       ]).widths([100,20,560]).fontSize(10).bold().alignment('left').end);       
       var sqry;
       sqry = " select" +
             " id, nombre" +
             " from tblentregable_cha" +
             " where id_charter = " + itm.id +
             " order by nombre";
       //console.log(sqry);
       await this.authService.ejecuta1(sqry)
       .then(
         data  => {        
           //this.loading =  false;                        
           var dat = JSON.stringify(data);
           var res = JSON.parse(dat);     
           if (res.length!=0){ 
             for(var i = 0; i < res.length;i++){               
               pdf.add(new Table([             
                [{text:"",fillColor: '#B0A879',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#FFFFFF']}, 
                  {text:i+1,borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#CCCCCC']}, 
                  {text:res[i].nombre,borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#CCCCCC']},]
               ]).widths([100,20,560]).fontSize(10).bold().alignment('left').end);                
             }
           }           
       });
       //+++++++++++++++++++++++++++++++++++++++++++++++++++
       pdf.add(new Table([             
        [{text:"Fecha de inicio: ",fillColor: '#B0A879',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}, 
        {text:itm.fechaestini,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}, 
        {text:"Fecha de cierre",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
        {text:itm.fechaestfin,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}]
       ]).widths([100,235,100,236]).fontSize(10).bold().alignment('left').end);   
       
       pdf.add(new Table([             
        [{text:"Integrantes del equipo ",fillColor: '#B0A879',alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}, 
        {text:"Equipo de soporte ",fillColor: '#B0A879',alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}]
       ]).widths([344,345]).fontSize(10).bold().alignment('left').end);  
       
       var col1=Array()
       var col2=Array()
       var col3=Array()
       var col4=Array()

//********************************** */

sqry = " select" + 
" id_personal as id, concat(tblpersona_tl.nombre,apaterno,amaterno) as nombre, titulo " + 
" from tblintegrante_cha,tblpersona_tl" +             
" left join tblexperiencia_tl on tblexperiencia_tl.id_persona=tblpersona_tl.id "+
" where tblintegrante_cha.id_personal = tblpersona_tl.id" + 
" and id_charter = " + itm.id +
" order by nombre";      
await this.authService.ejecuta1(sqry)
.then(
  data  => {        
    //this.loading =  false;                        
    var dat = JSON.stringify(data);
    var res = JSON.parse(dat);     
    if (res.length!=0){
      
      for(var i = 0; i < res.length;i++){        
        col1.push([{text:(i+1).toString()},
                  {text:res[i].nombre},
                  {text:res[i].titulo}]);       
      }
    }else {
      col1.push([{text:""},
      {text:""},
        {text:""}]); 
      }
});

sqry = " select" + 
" id_equipo as id, concat(tblpersona_tl.nombre,apaterno,amaterno) as nombre, titulo as job" + 
" from tblequipo_cha,tblpersona_tl" +              
" left join tblexperiencia_tl on tblexperiencia_tl.id_persona=tblpersona_tl.id "+
" where tblequipo_cha.id_equipo = tblpersona_tl.id" + 
" and id_charter = " + itm.id +
" order by nombre";
await this.authService.ejecuta1(sqry)
.then(
  data  => {        
    //this.loading =  false;                        
    var dat = JSON.stringify(data);
    var res = JSON.parse(dat);     
    if (res.length!=0){
      
      for(var i = 0; i < res.length;i++){        
        col2.push([{text:(i+1).toString()},
                  {text:res[i].nombre},
                  {text:res[i].job}]);       
      }
    }else {
      col2.push([{text:""},
      {text:""},
        {text:""}]); 
      }
});
sqry = " select" +
" id, nombre" +
" from tblmaterial_cha" +
" where id_charter = " + itm.id +
" order by nombre";
await this.authService.ejecuta1(sqry)
.then(
  data  => {        
    //this.loading =  false;                        
    var dat = JSON.stringify(data);
    var res = JSON.parse(dat);     
    if (res.length!=0){      
      for(var i = 0; i < res.length;i++){        
        col3.push([{text:(i+1).toString()},
                  {text:res[i].nombre}]);       
      }
    }else {
      col3.push([{text:""},
        {text:""}]); 
      }
});
sqry = " select" +
" id, nombre" +
" from tblentrenamiento_cha" +
" where id_charter = " + itm.id +
" order by nombre";
await this.authService.ejecuta1(sqry)
.then(
  data  => {        
    //this.loading =  false;                        
    var dat = JSON.stringify(data);
    var res = JSON.parse(dat);     
    if (res.length!=0){
      
      for(var i = 0; i < res.length;i++){        
        col4.push([{text:(i+1).toString()},
                  {text:res[i].nombre}]);       
      }

    }else {
      col4.push([{text:""},
        {text:""}]); 
      }
});
/************************************* */

       pdf.add(new Table([             
        [
          new Table([    
              [{text:"",fillColor: '#CCCCCC',alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}, 
               {text:"Integrante ",fillColor: '#CCCCCC',alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
               {text:"Titulo ",fillColor: '#CCCCCC',alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}
              ]]).widths([45,135,135]).end
          , 
          new Table([   
            [{text:"",fillColor: '#CCCCCC',alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}, 
            {text:"Equipo ",fillColor: '#CCCCCC',alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
            {text:"Job ",fillColor: '#CCCCCC',alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}
           ]]).widths([45,135,135]).end
        ]
       ]).widths([344,345]).fontSize(10).bold().alignment('left').end);  
       pdf.add(new Table([             
        [ new Table(col1 ).widths([45,135,135]).end, 
          new Table(col2 ).widths([45,135,135]).end]
       ]).widths([344,345]).fontSize(10).bold().alignment('left').end);  

       pdf.add(new Table([             
        [{text:"Materiales ",fillColor: '#B0A879',alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}, 
        {text:"Entrenamiento ",fillColor: '#B0A879',alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}]
       ]).widths([344,345]).fontSize(10).bold().alignment('left').end);  
       pdf.add(new Table([             
        [
          new Table([    
              [{text:"		 ",fillColor: '#CCCCCC',alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}, 
               {text:"Material ",fillColor: '#CCCCCC',alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}]
              ]).widths([45,280]).end
          , 
          new Table([   
            [{text:"		 ",fillColor: '#CCCCCC',alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}, 
            {text:"Entrenamiento ",fillColor: '#CCCCCC',alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
           ]]).widths([45,280]).end
        ]
       ]).widths([344,345]).fontSize(10).bold().alignment('left').end);  
       pdf.add(new Table([             
        [ new Table(col3 ).widths([45,280]).end, 
          new Table(col4 ).widths([45,280]).end]
       ]).widths([344,345]).fontSize(10).bold().alignment('left').end); 

       pdf.add(new Table([             
        [{text:"Facilitador ",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}, 
        {text:itm.facilitador,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}]
       ]).widths([100,590]).fontSize(10).bold().alignment('left').end); 
       
       pdf.add(new Table([             
        [{text:"Patrocinador ",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}, 
        {text:itm.patrocinador,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
        {text:"Firma / Fecha",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
        {text:itm.fechapat,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
        
        ]
       ]).widths([100,236,100,236]).fontSize(10).bold().alignment('left').end); 
       
       pdf.add(new Table([             
        [{text:"Autoriza ",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']}, 
        {text:itm.vpmexico,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
        {text:"Firma / Fecha",fillColor: '#B0A879',alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
        {text:itm.fechavp,alignment:'left',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']},
      ]
       ]).widths([100,236,100,236]).fontSize(10).bold().alignment('left').end); 

      }   

    pdf.create().open();  
    setTimeout(function(){
      window.close();
    },4000);//
    
}
  async generateExcel() {
    let workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('Data');     
    worksheet.getColumn(1).fill = {type: 'pattern', pattern: 'solid',fgColor:{argb: 'BDB76B' }};    
    worksheet.getColumn(2).fill = {type: 'pattern', pattern: 'solid',fgColor:{argb: 'BDB76B' }};    
    worksheet.getColumn(3).fill = {type: 'pattern', pattern: 'solid',fgColor:{argb: 'FFFFFF' }};
    worksheet.getColumn(4).fill = {type: 'pattern', pattern: 'solid',fgColor:{argb: 'FFFFFF' }};
    worksheet.getColumn(5).fill = {type: 'pattern', pattern: 'solid',fgColor:{argb: 'FFFFFF' }};
    
    const title = 'CHARTER';  
    let titleRow = worksheet.addRow([title]);
    titleRow.font = { name: 'Arial', family: 4, size: 16, underline: 'double', bold: true }    
    worksheet.mergeCells('A1:I2');    
      
    var sqry;

    
    sqry = " select" +
           " id, id_matriz, nombre, numero, objetivo, facilitador, patrocinador, vpmexico, fechaini," +
           " fechaestini,fechaestfin,fechapat,fechavp" +
           " from tblcharter_cha" +
           " where id_matriz = " +this.id_charter +
           " order by nombre";
   
    console.log(sqry)
    await this.authService.ejecuta1(sqry)
    .then(
      data  => {    
       
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        console.log(res);    
        if (res.length!=0){
          this.id_n=res[0].id;
          this.charter=data;
          console.log(this.charter)
        }else{
          this.id_n=0;
          this.charter=null;
        }            
    },
    error => {
    });
    if (this.id_n>0){
    
    var c=worksheet.addRow(['','Nombre del proyecto',this.charter[0].nombre,'Número de proyecto',this.charter[0].numero]);
    c.eachCell((cell, number) => {
      if(number==4)
      cell.fill = {type: 'pattern', pattern: 'solid',fgColor:{argb: 'BDB76B' }};
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    });
    
    var c=worksheet.addRow(['','Fecha de inicio',this.charter[0].fechaini,'ID del proyecto',this.charter[0].id]);
    c.eachCell((cell, number) => {
      if(number==4)
      cell.fill = {type: 'pattern', pattern: 'solid',fgColor:{argb: 'BDB76B' }};
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    });


    var itm=this.charter[0];
      this.itm.id = itm.id;
    
      var sqry;
      sqry = " select" +
             " id, nombre" +
             " from tblantecedente_cha" +
             " where id_charter = " + itm.id +
             " order by nombre";
      //console.log(sqry);
      await this.authService.ejecuta1(sqry)
      .then(
        data  => {        
          //this.loading =  false;                        
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);     
          if (res.length!=0){
            var _ant = [];    
            var ant=worksheet.addRow([,'No','Antecedentes']);
            ant.eachCell((cell, number) => {
              cell.fill = {type: 'pattern', pattern: 'solid',fgColor:{argb: 'BDB76B' }};
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
            });
            for(var i = 0; i < res.length;i++){
              var c=worksheet.addRow([  i+1,res[i].nombre]);              
              c.eachCell((cell, number) => {
                cell.fill = {type: 'pattern', pattern: 'solid',fgColor:{argb: 'CCCCCC' }};
                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
              });
            }
          }
          this.ant = _ant;
      },
      error => {
          //this.loading =  false;
          //msg.fire('Datos incorrectos', '', 'error');
      });
      var c=worksheet.addRow(['','Objetivo',itm.objetivo]);
      c.eachCell((cell, number) => {
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      });
      

      //this.loading = true;          
      sqry = " select" +
             " id, nombre" +
             " from tblestrategia_cha" +
             " where id_charter = " + itm.id +
             " order by nombre"; 
      //this.loading =  true;
      console.log(sqry);
      await this.authService.ejecuta1(sqry)
      .then(
        data  => {        
          //this.loading =  false;                        
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);     
          if (res.length!=0){
            console.log(res); 
            var ant=worksheet.addRow(['No','Estrategia para alcanzar el objetivo']);
            ant.eachCell((cell, number) => {
              cell.fill = {type: 'pattern', pattern: 'solid',fgColor:{argb: 'BDB76B' }};
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
            });
            for(var i = 0; i < res.length;i++){
              var c=worksheet.addRow([i+1,res[i].nombre]); 
              c.eachCell((cell, number) => {
                cell.fill = {type: 'pattern', pattern: 'solid',fgColor:{argb: 'CCCCCC' }};
                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
              });
            }
          }
      },
      error => {
      });

      //this.loading = true;          
      sqry = " select" +
             " id, nombre" +
             " from tblentregable_cha" +
             " where id_charter = " + itm.id +
             " order by nombre";
      //this.loading =  true;
     await  this.authService.ejecuta1(sqry)
      .then(
        data  => {        
          //this.loading =  false;                        
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);     
          if (res.length!=0){
            var ant=worksheet.addRow(['No','Entregables']);
            ant.eachCell((cell, number) => {
              cell.fill = {type: 'pattern', pattern: 'solid',fgColor:{argb: 'BDB76B' }};
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
            });
            for(var i = 0; i < res.length;i++){
              var c=worksheet.addRow([i+1,res[i].nombre]); 
              c.eachCell((cell, number) => {
                cell.fill = {type: 'pattern', pattern: 'solid',fgColor:{argb: 'CCCCCC' }};
                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
              });
            }
          }          
      },
      error => {
          //this.loading =  false;
          //msg.fire('Datos incorrectos', '', 'error');
      });
      var c=worksheet.addRow(['','Fecha de inicio',itm.fechaestini]);
      c.eachCell((cell, number) => {
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      });
      var c=worksheet.addRow(['','Fecha de cierre',itm.fechaestfin]); 
      c.eachCell((cell, number) => {
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      });
      sqry = " select" + 
      " id_personal as id, concat(tblpersona_tl.nombre,apaterno,amaterno) as nombre, titulo " + 
      " from tblintegrante_cha,tblpersona_tl" +             
      " left join tblexperiencia_tl on tblexperiencia_tl.id_persona=tblpersona_tl.id "+
      " where tblintegrante_cha.id_personal = tblpersona_tl.id" + 
      " and id_charter = " + itm.id +
      " order by nombre";      
      await this.authService.ejecuta1(sqry)
      .then(
        data  => {        
          //this.loading =  false;                        
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);     
          if (res.length!=0){
            var ant=worksheet.addRow(['No','Integrantes del equipo','Titulo']);
            ant.eachCell((cell, number) => {
              cell.fill = {type: 'pattern', pattern: 'solid',fgColor:{argb: 'BDB76B' }};
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
            });
            for(var i = 0; i < res.length;i++){
              var c=worksheet.addRow([i+1,res[i].nombre,res[i].titulo]);  
              c.eachCell((cell, number) => {
                cell.fill = {type: 'pattern', pattern: 'solid',fgColor:{argb: 'CCCCCC' }};
                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
              });
            }
          }
      },
      error => {
          //this.loading =  false;
          //msg.fire('Datos incorrectos', '', 'error');
      });

      sqry = " select" + 
      " id_equipo as id, concat(tblpersona_tl.nombre,apaterno,amaterno) as nombre, titulo as job" + 
      " from tblequipo_cha,tblpersona_tl" +              
      " left join tblexperiencia_tl on tblexperiencia_tl.id_persona=tblpersona_tl.id "+
      " where tblequipo_cha.id_equipo = tblpersona_tl.id" + 
      " and id_charter = " + itm.id +
      " order by nombre";
     await this.authService.ejecuta1(sqry)
      .then(
        data  => {        
          //this.loading =  false;                        
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);     
          if (res.length!=0){
            var ant=worksheet.addRow(['No','Equipo de soporte','Job']);
            ant.eachCell((cell, number) => {
              cell.fill = {type: 'pattern', pattern: 'solid',fgColor:{argb: 'BDB76B' }};
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
            });
            for(var i = 0; i < res.length;i++){
              var c=worksheet.addRow([i+1,res[i].nombre,res[i].job]);    
              c.eachCell((cell, number) => {
                cell.fill = {type: 'pattern', pattern: 'solid',fgColor:{argb: 'CCCCCC' }};
                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
              });
            }
          }
      },
      error => {
          //this.loading =  false;
          //msg.fire('Datos incorrectos', '', 'error');
      });
      


      //this.loading = true;          
      sqry = " select" +
             " id, nombre" +
             " from tblmaterial_cha" +
             " where id_charter = " + itm.id +
             " order by nombre";
      //this.loading =  true;
      await this.authService.ejecuta1(sqry)
      .then(
        data  => {        
          //this.loading =  false;                        
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);     
          if (res.length!=0){
            var ant=worksheet.addRow(['No','Materiales']);
            ant.eachCell((cell, number) => {
              cell.fill = {type: 'pattern', pattern: 'solid',fgColor:{argb: 'BDB76B' }};
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
            });
            for(var i = 0; i < res.length;i++){
              var c=worksheet.addRow([i+1,res[i].nombre]); 
              c.eachCell((cell, number) => {
                cell.fill = {type: 'pattern', pattern: 'solid',fgColor:{argb: 'CCCCCC' }};
                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
              });

            }
          }
      },
      error => {
          //this.loading =  false;
          //msg.fire('Datos incorrectos', '', 'error');
      });

      //this.loading = true;          
      sqry = " select" +
             " id, nombre" +
             " from tblentrenamiento_cha" +
             " where id_charter = " + itm.id +
             " order by nombre";
     // this.loading =  true;
      await this.authService.ejecuta1(sqry)
      .then(
        data  => {        
          //this.loading =  false;                        
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);     
          if (res.length!=0){
            var ant=worksheet.addRow(['No','Entrenamientos']);
            ant.eachCell((cell, number) => {
              cell.fill = {type: 'pattern', pattern: 'solid',fgColor:{argb: 'BDB76B' }};
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
            });
            for(var i = 0; i < res.length;i++){
              var c=worksheet.addRow([i+1,res[i].nombre]);  
              c.eachCell((cell, number) => {
                cell.fill = {type: 'pattern', pattern: 'solid',fgColor:{argb: 'CCCCCC' }};
                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
              });
            }
          }
      },
      error => {
          //this.loading =  false;
          //msg.fire('Datos incorrectos', '', 'error');
      });
      
    var c=worksheet.addRow(['','Facilitador',itm.facilitador]);  
    c.eachCell((cell, number) => {
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    });
    
    var c=worksheet.addRow(['','Patrocinador',itm.patrocinador,'Firma / Fecha',itm.fechapat]);  
    c.eachCell((cell, number) => {
      if(number==4)
      cell.fill = {type: 'pattern', pattern: 'solid',fgColor:{argb: 'BDB76B' }};
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    });
    var cf=worksheet.addRow(['','Autoriza',itm.vpmexico,'Firma / Fecha',itm.fechavp]);  
    cf.eachCell((cell, number) => {
      if(number==4)
      cell.fill = {type: 'pattern', pattern: 'solid',fgColor:{argb: 'BDB76B' }};
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    });
    worksheet.getColumn(1).width = 2; 
    worksheet.getColumn(2).alignment={horizontal:"center",wrapText: true} 
    worksheet.getColumn(2).width = 60; 
    worksheet.getColumn(2).alignment={horizontal:"justify",wrapText: true}     
    worksheet.getColumn(2).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }

    worksheet.getColumn(3).width = 50;
    worksheet.getColumn(3).alignment={horizontal:"justify",wrapText: true} 
    worksheet.getColumn(4).width =30;
    worksheet.getColumn(4).alignment={horizontal:"justify",wrapText: true} 
    worksheet.getColumn(5).width =30;
    worksheet.getColumn(5).alignment={horizontal:"justify",wrapText: true}     
  }
    let footerRow = worksheet.addRow(['Report V1.']);
    footerRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFCCFFE5' }
    };
    footerRow.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'CarData.xlsx');
    });  
    setTimeout(function(){
      window.close();
    },4000);
  }

}
